import ReportsSpreadsheetHeader from 'modules/reports/components/Spreadsheet/Header'
import ReportsSpreadsheetAppend from 'modules/reports/components/Spreadsheet/Append'
import {useReportsSpreadsheetContext} from 'modules/reports/components/Spreadsheet/ReportsSpreadsheet.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
// import useStyles from './ReportsSpreadsheetHead.styles'

type Props = {}

function ReportsSpreadsheetHead(props: Props) {
  // const classes = useStyles()
  const {prefix, columns, onNewColumn} = useReportsSpreadsheetContext()
  const p = usePrefix(prefix + '-head')

  return (
    <thead data-testid={p()}>
      <tr>
        {columns.map((column, index) => (
          <ReportsSpreadsheetHeader key={index} column={column} />
        ))}

        {onNewColumn && <ReportsSpreadsheetAppend />}
      </tr>
    </thead>
  )
}

export default ReportsSpreadsheetHead
